import script from "./UIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIcon.vue?vue&type=script&setup=true&lang=ts"

import "./UIcon.vue?vue&type=style&index=0&id=8c509540&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c509540"]])

export default __exports__